import $ from 'jquery';
import 'slick-carousel/slick/slick';
import 'bootstrap';

$('.slick-row').slick({
    dots: false,
    prevArrow: $('.arrow-left'),
    nextArrow: $('.arrow-right'),
});